import React, { useEffect, useState } from 'react';
import { Form } from 'antd';
import moment from 'moment';
import {
  addChosenPassengersService,
  deleteCustomerChosenPassengers,
  editSavedPassengerService,
  getCustomerChosenPassengers,
} from '../../../../../../services/customer/profileServices';
import ChosenPassenger from './components/ChosenPassenger';
import EditSavedPassengerModal from '../../../../components/modals/editSavedPassengerModal/EditSavedPassengerModal';
import EditSavedPassengerDrawer from '../../../../components/drawers/editSavedPassengerDrawer/EditSavedPassengerDrawer';
import useTranslation from '../../../../../hooks/translation/useTranslation';

function SavedPassengers() {
  const [data, setData] = useState(null);
  const [showEdit, setShowEdit] = useState(false);
  const [showAddPassengers, setShowAddPassengers] = useState(false);
  const [form] = Form.useForm();
  const { trans } = useTranslation();

  const fetchData = async () => {
    const res = await getCustomerChosenPassengers();
    if (res.status === 'success') {
      setData(res.data);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDelete = async (id) => {
    const res = await deleteCustomerChosenPassengers(id);
    if (res.status === 'success') {
      fetchData();
    }
  };

  const handleAddPassengers = () => {
    const emptyData = {
      first_name: '',
      last_name: '',
      id_number: '',
      birth_date: moment(), // Convert to moment object
      id: 1,
      key: 1,
      label: '',
    };
    form.setFieldsValue(emptyData);
    setShowAddPassengers(true);
  };

  const handleAdd = async (values) => {
    if (values) {
      await addChosenPassengersService(values).then((res) => {
        if (res.status === 'success') {
          fetchData();
          setShowAddPassengers(false);
        }
      });
    }
  };

  const handleChooseEdit = async (id) => {
    const foundDate = data?.find((passenger) => passenger?.id === id);
    form.setFieldsValue({
      ...foundDate,
      ...(foundDate?.birth_date && {
        birth_date: moment(foundDate?.birth_date),
      }),
    });
    setShowEdit(true);
  };

  const handleEdit = async (values) => {
    if (values?.id) {
      const res = await editSavedPassengerService(values?.id, values);
      if (res?.status === 'success') {
        setShowEdit(false);
        fetchData();
      }
    }
  };

  return (
    <div className="flex flex-col gap-5">
      <button
        type="button"
        className="text-primary bg-transparent border-none font-big-bold cursor-pointer text-base text-left"
        onClick={handleAddPassengers}
      >
        {trans('add')}
      </button>
      <EditSavedPassengerModal
        showEditPassenger={showAddPassengers}
        setShowPassenger={setShowAddPassengers}
        form={form}
        handleSubmit={handleAdd}
      />
      <EditSavedPassengerDrawer
        form={form}
        handleSubmit={handleAdd}
        show={showAddPassengers}
        setShow={setShowAddPassengers}
      />
      {data
        && data?.map((passenger) => (
          <ChosenPassenger
            key={passenger.id}
            passenger={passenger}
            handleDelete={handleDelete}
            handleChooseEdit={handleChooseEdit}
          />
        ))}
      <EditSavedPassengerModal
        showEditPassenger={showEdit}
        setShowPassenger={setShowEdit}
        form={form}
        handleSubmit={handleEdit}
      />
      <EditSavedPassengerDrawer
        form={form}
        handleSubmit={handleEdit}
        show={showEdit}
        setShow={setShowEdit}
      />
    </div>
  );
}

export default SavedPassengers;
